import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmpresaService } from '../../services/empresa.service';
import { EditEmpresaService } from '../../services/edit-empresa.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { camposDirecciones } from '../../assets/dataErrors';
import { EmpresaHelperService } from '../../services/editar-empresa-helper.service';
@Component({
    selector: 'app-edit-direccion',
    templateUrl: './edit-direccion.component.html',
    styleUrls: ['../../dir-urbana/dir-urbana.component.css'],
})
export class EditDireccionComponent implements OnInit {
    empresaForm: FormGroup;
    editarDireccion = true;
    direccionFormGroup;
    municipios;
    municipio;
    departamentos = [];
    datosCargados = false;
    direccionActual;
    direccionActualView;
    userId;
    camposDirecciones: any = camposDirecciones;
    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private empresaservise: EmpresaService,
        private editarService: EditEmpresaService,
        private router: Router,
        private empresaHelperService: EmpresaHelperService
    ) {}

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.userId = params['id'];
        });

        this.editarDireccion = true;
        // Llama a la función para cargar los departamentos
        this.getDepartamentos();
        this.empresaForm = this.fb.group({
            direccion: this.fb.group({
                departamento: [null, [Validators.required]],
                municipioId: [null, [Validators.required]],
                zona: ['', [Validators.required]],
                complemento: ['', Validators.required],
                viaPrincipalTipo: [null, [Validators.required]],
                viaPrincipalNumero: [null, [Validators.required]],
                viaPrincipalLetra: [null],
                prefijoBis: [null],
                letraPrefijo: [null],
                viaPrincipalCuadrante: [null],
                viaGeneradoraNumero: [null, [Validators.required]],
                viaGeneradoraLetra: [null],
                numeroPlaca: [null, [Validators.required]],
                viaGeneradoraCuadrante: [null],
            }),
        });
        this.direccionFormGroup = this.empresaForm.get('direccion');
        this.getDireccion();
    }

    /* Metodos para obtener los datos y mostrarlos en el formulario */
    getDepartamentos() {
        this.empresaservise.getDepartamentos().subscribe((departamento) => {
            this.departamentos = departamento;
            this.datosCargados = true;
        });
    }

    getMunicipio() {
        const idDparta = this.empresaForm
            .get('direccion')
            .get('departamento').value;
        if (this.departamentos === null) {
            return (this.municipios = []);
        }
        this.empresaservise.getMunicipios(idDparta).subscribe((data) => {
            this.municipios = data;
        });
    }

    async getDireccion() {
        try {
            if (this.userId) {
                console.log('el id es:' + this.userId);
                this.direccionActual =
                    await this.editarService.getEmpresaActualAdministrador(
                        `agente-vigilado/${this.userId}`
                    );
            } else {
                this.direccionActual =
                    await this.editarService.getEmpresaActual(
                        'agente-vigilado'
                    );
            }
            this.empresaForm
                .get('direccion')
                .get('departamento')
                .patchValue(
                    this.direccionActual.direccion.municipio.departamentoId
                );
            this.getMunicipio();
            this.empresaForm
                .get('direccion')
                .get('municipioId')
                .patchValue(this.direccionActual.direccion.municipioId);
            this.empresaForm.patchValue(this.direccionActual);
            if (this.direccionActual.direccion.prefijoBis === 'false') {
                this.empresaForm
                    .get('direccion')
                    .get('prefijoBis')
                    .patchValue(false);
            }

            this.empresaForm.valueChanges.subscribe((val) => {
                this.onFormChange();
            });
            this.onFormChange();
        } catch (error) {
            console.log('Ocurrió un error obteniendo la información', error);
        }
    }
    /* Metodo para la actualizacion de dato---------- */
    async putDireccion() {
        try {
            const enpointId = `agente-vigilado/direccion/${this.direccionActual.id}`;
            const direccionActual = this.empresaForm.get('direccion').value;
            Object.keys(direccionActual).forEach((key) => {
                if (direccionActual[key] === 'null') {
                    direccionActual[key] = null;
                }
            });

            await this.editarService.putEmpresaActual(
                enpointId,
                direccionActual
            );
            Swal.fire(
                '',
                'Dirección actualizada correctamente',
                'success'
            ).then((result) => {
                if (result.isConfirmed) {
                    this.router.navigate(['/inicio']);
                }
            });
        } catch (error) {
            console.log('Ocurrió un error al actualizar', error);
        }
    }

    quitarValidador() {
        this.empresaHelperService.quitarValidador(this.empresaForm);
    }

    onFormChange() {
        this.direccionActualView =
            this.empresaHelperService.visualizarDireccion(this.empresaForm);
    }
    // Función para verificar si el campo es inválido y tocado
    esInvalidoYtocado(campo: string): boolean {
        const control = this.empresaForm.get(campo);
        return control.invalid && control.touched;
    }

    public submitEditar() {
        const direccion = this.empresaForm.get('direccion');
        this.quitarValidador();
        if (direccion.valid) {
            this.putDireccion();
            console.log('La dirección es válida');
            // Realiza las acciones necesarias cuando el formulario es válido
        } else {
            this.empresaForm.markAllAsTouched();
            console.log('Ocurrió un error en el formulario');
        }
    }
}
